import { useMemo } from 'react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ServiceProvidersQueries } from '@frontend/api-service-providers';
import { useAppScopeStore } from '@frontend/scope';
import { useGetCalendarEventsV3Data } from '../../hooks';
import { getDateString } from '../../utils/date-helpers';
import { convertV3CalendarEventToAppointmentDetails } from '../../views/CalendarV3/helpers';

export const useGetAppointments = (startDate: string, endDate: string) => {
  const { selectedLocationIds } = useAppScopeStore();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { locationTimezoneMap } = SchedulerV3.Helpers.useScheduleLocationTimezoneShallowStore();

  const appointmentListV2Query = ServiceProvidersQueries.useListAppointments({
    startDate,
    endDate,
    locationIds: selectedLocationIds,
    enabled: !isScheduleV3FlagEnabled,
  });

  // TODO: send end date as well once we add support for custom date range in widget
  const appointmentListV3Query = useGetCalendarEventsV3Data({
    selectedDate: getDateString(startDate),
    selectedLocationIds: selectedLocationIds,
  });

  const formattedAppointmentListV3Data = useMemo(() => {
    return convertV3CalendarEventToAppointmentDetails(appointmentListV3Query.data?.events ?? [], locationTimezoneMap);
  }, [appointmentListV3Query.data?.events, locationTimezoneMap]);

  const isLoading = appointmentListV2Query.isFetching || appointmentListV3Query.isFetching;

  const data = isScheduleV3FlagEnabled
    ? formattedAppointmentListV3Data
    : appointmentListV2Query.data?.appointments ?? [];

  return { appointments: data, isLoading };
};
